import React from 'react';
import { Card } from '@avila-tek/ui/src';
import { ShopCart, ShopCartItem, TTally, Variant } from '../../../models';
import { useEditShopCart } from '../../../hooks';
import InvoiceItem from './InvoiceItem';
import InvoiceTotal from './InvoiceTotal';

interface InvoiceProps {
  shopCart: ShopCart;
  total: TTally;
}

function Invoice({ shopCart, total }: InvoiceProps) {
  const { productsShopItems, benefitsShopItems, plansShopItems } =
    useEditShopCart(shopCart);

  const getVariantTitle = (variant: Variant) =>
    `${variant?.option?.option1 ?? ''} ${variant?.option?.option2 ?? ''} ${
      variant?.option?.option3 ?? ''
    }`;

  const getQuantity = (item: ShopCartItem) =>
    item.shopList.reduce((acc, cur) => acc + cur.quantity, 0);
  return (
    <Card className="p-4 px-6 ">
      <h3 className="text-purple-300 font-semibold text-lg uppercase my-2">
        Productos
      </h3>
      <hr className="mb-3" />
      <div className="flex flex-col">
        {productsShopItems.length > 0
          ? productsShopItems.map((item) => (
              <InvoiceItem
                title={item?.title}
                subtitle={getVariantTitle(item[0]?.variant)}
                price={item.price}
                quantity={getQuantity(item)}
              />
            ))
          : null}
        {benefitsShopItems.length > 0
          ? benefitsShopItems.map((item) => (
              <>
                {item.shopList.map((shopItem) => (
                  <InvoiceItem
                    title="Beneficio"
                    subtitle={item?.title}
                    price={shopItem?.price}
                    quantity={shopItem.quantity}
                  />
                ))}
              </>
            ))
          : null}
        {plansShopItems.length > 0
          ? plansShopItems.map((item) => (
              <InvoiceItem
                title="Subscrición"
                subtitle={item?.title}
                price={item.price}
                quantity={getQuantity(item)}
              />
            ))
          : null}
      </div>
      <InvoiceTotal total={total} />
    </Card>
  );
}

export default Invoice;
